import styled from 'styled-components';

export interface IButtonProps {
    isSelected?: boolean;
    onClick?: (eventTypeId: number) => void;
}

export const RotationInfoWrapper = styled.div`
    display: flex;
    position: relative;
`;

export const RotationContextInfo = styled.div`
    display: flex;
`;

export const RotationInfoItem = styled.div`
    padding: 0px 10px;
    font-size: 0.6rem;
    display: grid;
    grid-template-columns: 115px calc(100% - 115px);
    flex: 0 0 auto;
    line-height: 0.7rem;
    gap: 0;

    @media only screen and (max-width: 1280px) {
        padding: 0 0 0 10px;
    }
`;

export const InfoButtonWrapper = styled.div`
    flex: 0 0 auto;
`;
